<template>
  <div class="flex w-full items-center justify-between">
    <SFHeadline class="!font-semibold md:text-lg" size="xl" tag="p">
      {{ $t('filter_header.title') }}
    </SFHeadline>
    <SFButton
      class="group my-3 -mr-2 bg-gray-100 md:bg-transparent hover:md:bg-gray-100"
      fab
      variant="raw"
      data-testid="close-filters"
      :aria-label="$t('filter_header.close')"
      @click="toggleItem"
    >
      <template #icon>
        <IconClose
          class="size-4 md:text-gray-500 group-hover:md:text-gray-900"
        />
      </template>
    </SFButton>
  </div>
</template>

<script setup lang="ts">
import { SFButton, SFHeadline } from '#storefront-ui/components'

defineProps<{ toggleItem: () => void }>()
</script>
